import * as React from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel } from "@mui/material";

type IProps = {
  formik: any;
  name: string;
  label: string;
};

const FormikSwitch: React.FC<IProps> = ({ formik, name, label }) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={formik.values[name]}
          onChange={formik.handleChange}
          name={name}
        />
      }
      label={label}
    />
  );
};
export default FormikSwitch;
